const Terminal = () => import("./views/Terminal.vue");

export default [
  {
    path: "/terminal",
    name: "terminal",
    component: Terminal,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN", "ROLE_COOK"],
      clarityUpgradeReason: "Terminal",
    },
  },
];
